import { useUsuarioStore } from '@/store/usuarioStore';

export default function scheduler() {
  const usuarioStore = useUsuarioStore();

  const loop = async () => {
    const activo = true;
    while (activo) {
      try {
        await usuarioStore.getSession();
        await usuarioStore.refrescarResumenGarantiasUsuario();
      } catch (error) {
        console.error("Error en el scheduler:", error);
      }
      await new Promise(resolve => setTimeout(resolve, 10000));
    }
  };

  loop();
}